import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class IssueTypeColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.IssueType
  declare readonly dataType: typeof MemexColumnDataType.IssueType
  declare readonly userDefined: false
}
